import React, { useCallback, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { gallerySites, type GallerySite } from '../../data/gallery';
import { GalleryCard } from '../gallery/GalleryCard';
import { GalleryPreviewModal } from '../gallery/GalleryPreviewModal';
const featuredSites = gallerySites.filter(site => site.featured);
export function RealSites() {
  const [selected, setSelected] = useState<GallerySite | null>(null);
  const close = useCallback(() => setSelected(null), []);
  return <section aria-labelledby="real-sites" className="bg-gray-50 px-[clamp(1rem,4vw,6rem)] py-20 lg:py-28" data-id="element-1014" data-mp="2fgn9veev2ad0">
      <p className="text-sm font-bold uppercase tracking-[0.14em] text-brand-red" data-id="element-1015" data-mp="2kg85pfyqi2li">Proof, not promises</p>
      <h2 id="real-sites" className="mt-3 text-[clamp(2rem,3vw,3.5rem)] font-extrabold leading-tight tracking-tight text-brand-black" data-id="element-1016" data-mp="2pejk83zz51a2">
        Real businesses, real sites, built fast.
      </h2>
      <p className="mt-4 max-w-[60ch] text-[clamp(1.0625rem,1.2vw,1.375rem)] leading-relaxed text-gray-600" data-id="element-1017" data-mp="v23er5f05r69">
        Every one of these started as a 3-day build, then kept growing one change at a time.
      </p>

      <ul className="mt-12 grid gap-6 sm:grid-cols-2 xl:grid-cols-4" data-id="element-1018" data-mp="17w1uan4zzljt">
        {featuredSites.map(site => <li key={site.id} data-id="element-1019" data-mp="12vxfd1jqmyvp">
            <GalleryCard site={site} onOpen={setSelected} data-id="element-1020" data-mp="yx84bfm69tf8" />
          </li>)}
      </ul>

      <div className="mt-10 flex flex-col items-start gap-5 sm:flex-row sm:items-center sm:gap-8" data-id="element-1021" data-mp="1vmpadvp2hhhg">
        <a href="#/design/gallery" className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-brand-red px-7 py-3.5 font-bold text-white transition-colors duration-150 ease-out hover:bg-brand-red-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-red focus-visible:ring-offset-2" data-id="element-1022" data-mp="1qo48lru62pqw">
          See our full gallery
          <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1023" data-mp="b4rcidcmun2q" />
        </a>
        <a href="#/industries" className="group inline-flex items-center gap-1.5 font-bold text-brand-black transition-colors duration-150 ease-out hover:text-brand-red focus:outline-none focus-visible:underline" data-id="element-1024" data-mp="66pt1rbaolqq">
          See every industry we serve
          <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-1025" data-mp="3ut4dswp9jr41" />
        </a>
      </div>

      <GalleryPreviewModal site={selected} onClose={close} data-id="element-1026" data-mp="3l3kr1fyfjd3w" />
    </section>;
}